import { TableTagCell } from "@src/components/data-components/DocumentationCollection/cells/CustomFieldTagCell";
import { IApiCollectionItemHelper } from "@src/to-be-removed/LocalData/General/DataObjectHelpers/Property/IApiCollectionItemHelper";
import { DataTableDataCellValue } from "../components/deprecated/DataTable/DataTable";
import { CompanyCollectionItemData } from "../to-be-removed/LocalData/Company/Collections/CompanyCollectionItemData";
import { CustomFieldDataType } from "../to-be-removed/LocalData/Company/Collections/CustomFieldDataType";
import { V2CollectionItemDataHelper } from "../to-be-removed/LocalData/General/DataObjectHelpers/Property/V2CollectionItemDataHelper";
import { DataSource } from "../to-be-removed/LocalData/General/DataSource";
import { PropertyCollectionItemData } from "../to-be-removed/LocalData/Property/Collections/PropertyCollectionItemData";
import { PropertyCustomFieldData } from "../to-be-removed/LocalData/Property/Collections/PropertyCustomFieldData";
import { PropertyData } from "../to-be-removed/LocalData/Property/PropertyData";
import { CollectionItemData } from "../to-be-removed/LocalData/collections/CollectionItemData";
import { FormulaUtilities } from "./formulaUtilities";
import { StringUtilities } from "./stringUtilities";
import { SystemsAndComponentsUtilities } from "./systemsAndComponentsUtilities";
import { IRawCollectionItemHelper } from "@src/to-be-removed/LocalData/General/DataObjectHelpers/Property/IRawCollectionItemHelper";

export class CollectionUtilities {
  static async getValueStringForValue(
    helper: V2CollectionItemDataHelper | IApiCollectionItemHelper | IRawCollectionItemHelper,
    fieldID: string,
    value: any
  ): Promise<string> {
    const fieldHelper = helper.getField(fieldID);
    if (!fieldHelper) console.warn(`[CollectionUtilities.getValueStringForValue] did not find helper field for ${fieldID}`);
    const decodedValue = fieldHelper?.fullDecode(value);
    const stringRepresentation = fieldHelper?.getStringRepresentation(decodedValue);
    return stringRepresentation ?? "";
  }

  static getValueString(
    dataSource: DataSource | undefined,
    field: PropertyCustomFieldData | undefined,
    item: PropertyCollectionItemData | CompanyCollectionItemData
  ): Promise<string> {
    if (field?.dataType === CustomFieldDataType.FORMULA) {
      return CollectionUtilities.calculateFormula(field, item);
    }

    return (
      dataSource?.getValue().then(async (val) => {
        const property = item.parent?.parent instanceof PropertyData ? item.parent?.parent : undefined;

        if (
          field?.dataType === CustomFieldDataType.TENANTS ||
          field?.dataType === CustomFieldDataType.CONTRACTORS ||
          field?.dataType === CustomFieldDataType.COLLECTION_ITEM ||
          field?.dataType === CustomFieldDataType.CUSTOM_DATA_TYPE ||
          field?.dataType === CustomFieldDataType.DATE
        ) {
          const results: string[] = [];
          for (const value of val) {
            for (const element of value.values) {
              const result = field.dataType.getStringRepresentation(element, field.dataOptions, { propertyID: property?.id });
              if (typeof result === "string") {
                results.push(result);
              } else {
                results.push(await result);
              }
            }
          }
          return results.join(", ");
        }
        let text = val.map((val) => val.values.join(", ")).join(", ");
        if (field?.dataType === CustomFieldDataType.NORWEGIAN_STANDARDS && field.dataOptions.standardID) {
          return SystemsAndComponentsUtilities.getOptionWithKey(field.dataOptions.standardID ?? "", text)?.title ?? "";
        }
        if (field?.dataType === CustomFieldDataType.NUMBER && !Number.isNaN(Number.parseFloat(text))) {
          text = Number.parseFloat(text).toLocaleString();
        }
        return text;
      }) ?? Promise.resolve("")
    );
  }

  static getTableData(
    dataSource: DataSource | undefined,
    field: PropertyCustomFieldData | undefined,
    item: PropertyCollectionItemData | CompanyCollectionItemData
  ): DataTableDataCellValue | Promise<DataTableDataCellValue> {
    if (field?.dataType === CustomFieldDataType.TAGS) {
      return (
        dataSource?.getValue().then((response) => {
          const tags: string[] = [];
          for (const value of response.map((res) => res.values)) {
            for (const list of value) {
              if (Array.isArray(list)) {
                for (const tag of list) {
                  if (typeof tag === "string") {
                    tags.push(tag);
                  }
                }
              }
            }
          }
          return {
            element: <TableTagCell tagIDs={tags} />,
          };
        }) ?? ""
      );
    }
    return this.getValueString(dataSource, field, item);
  }

  static async calculateFormula(
    field: PropertyCustomFieldData,
    item: PropertyCollectionItemData | CompanyCollectionItemData | CollectionItemData
  ): Promise<string> {
    const formula = StringUtilities.replaceAll(field.dataOptions.formula ?? "", " ", "");
    const result = await FormulaUtilities.parseExpression(formula, item);
    return Number.isNaN(result) ? "" : String(result);
  }
}
